import React from 'react';
import {
  DateToDateAndTimeFormat,
  FormatAsCurrencyForLocale
} from '@PetSureAustralia/petsure-react-ui-library/distLib/helpers';
import PropTypes from 'prop-types';

export const PaymentSummarySuccess = ({
  totalAmountPaid,
  transactionTime,
  receiptNumber,
  onMakeAnotherPayment,
  onUpdateBankDetails
}) => {
  return (
    <div>
      <div className="summary-container">
        <div className="success-payment-header">
          <span>Please allow up to 20 minutes for this payment to be reflected.</span>
        </div>
        <p>
          Thanks. Your payment for{' '}
          <span className="payment-highlight">{FormatAsCurrencyForLocale(totalAmountPaid)}</span> has been received on
          <span className="payment-highlight"> {DateToDateAndTimeFormat(transactionTime)}</span>.
          <br />
          Reference number is <span className="payment-highlight">{receiptNumber}</span>.
          <br />
          <br />
          Please update your banking details for future premium collections and claims payments.
        </p>
      </div>
      <div className="button-container">
        <button
          type="button"
          className="button primary"
          onClick={onMakeAnotherPayment}
        >
          <span className="labelText">Make another payment</span>
        </button>
        <button
          type="button"
          className="button primary"
          onClick={onUpdateBankDetails}
        >
          <span className="labelText">Update bank details</span>
        </button>
      </div>
    </div>
  );
};

PaymentSummarySuccess.propTypes = {
  totalAmountPaid: PropTypes.number,
  onMakeAnotherPayment: PropTypes.func,
  transactionTime: PropTypes.string,
  receiptNumber: PropTypes.string,
  onUpdateBankDetails: PropTypes.func
};
